import { Env } from './env';
import { config } from './environment';
import { Region } from './region';
import { countryValues } from './countries/country';

export {
  Env,
  Region,
  countryValues as COUNTRY_CONFIG,
  config as APP_CONFIG
}



// WEBPACK FOOTER //
// ./src/environment/index.ts